import { HttpErrorResponse } from '@angular/common/http';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ILocalAgendamento } from '@app/modules/agendamento/model/local_agendamento.model';
import { ITipoFormulario } from '@app/modules/formulario/model/tipo_formulario.model';
import { IFornecedor } from '@app/modules/fornecedor/models/fornecedor.model';
import { ICategoriaMaterial } from '@app/modules/material/model';
import { IMotivoCancelamento } from '@app/modules/motivo_cancelamento/model/motivo-cancelamento.model';
import { IPaciente } from '@app/modules/paciente/models/paciente.model';
import { IPlanoSaude } from '@app/modules/plano_saude/models/plano_saude.model';
import { IPortador } from '@app/modules/portador/model/portador.model';
import { IProcedimento } from '@app/modules/procedimento/models/procedimento.model';
import { ITipoProcedimento } from '@app/modules/procedimento/models/tipo_procedimento.model';
import { IProfissional } from '@app/modules/profissional/models/profissional.model';
import { IProtocolo } from '@app/modules/protocolo/models/protocolo.model';
import {
  ConfirmDialogComponent,
  ConfirmDialogData
} from '@app/shared/components';
import { Utils as UtilsProject } from '@app/shared/helpers/utils';
import { Observable, of } from 'rxjs';
import { debounceTime, filter, map, mergeMap, tap } from 'rxjs/operators';
import {
  EntityService,
  ErroMessages,
  IEntity,
  IErroMessages,
  IRoute,
  TokenService,
  Utils
} from 'viggo-sistemas-core-web';
import { FastCategoriaMateriaComponent } from '../fast-categoria-materia/fast-categoria-materia.component';
import { FastFornecedorComponent } from '../fast-fornecedor/fast-fornecedor.component';
import { FastLocalAgendamentoComponent } from '../fast-local-agendamento/fast-local-agendamento.component';
import { FastMotivoCancelamentoComponent } from '../fast-motivo-cancelamento/fast-motivo-cancelamento.component';
import { FastPacienteComponent } from '../fast-paciente/fast-paciente.component';
import { FastPlanoSaudeComponent } from '../fast-plano-saude/fast-plano-saude.component';
import { FastPortadorComponent } from '../fast-portador/fast-portador.component';
import { FastProcedimentoComponent } from '../fast-procedimento/fast-procedimento.component';
import { FastProfissionalComponent } from '../fast-profissional/fast-profissional.component';
import { FastProtocoloComponent } from '../fast-protocolo/fast-protocolo.component';
import { FastTipoFormularioComponent } from '../fast-tipo-formulario/fast-tipo-formulario.component';
import { FastTipoProcedimentoComponent } from '../fast-tipo-procedimento/fast-tipo-procedimento.component';

export type InsertType =
  | 'categoria'
  | 'protocolo'
  | 'tipo_procedimento'
  | 'procedimento'
  | 'fornecedor'
  | 'tipo_formulario'
  | 'plano_saude'
  | 'paciente'
  | 'profissional'
  | 'local_agendamento'
  | 'motivo_cancelamento';

export const components: {
  [key: string]: { component: any; config: MatDialogConfig };
} = {
  categoria: {
    component: FastCategoriaMateriaComponent,
    config: {
      panelClass: [
        'dialog-sem-padding',
        'custom-container',
        'position-relative'
      ],
      position: {
        top: '0px'
      },
      data: {
        entity: {} as ICategoriaMaterial
      }
    }
  },
  protocolo: {
    component: FastProtocoloComponent,
    config: {
      panelClass: [
        'dialog-sem-padding',
        'custom-container',
        'position-relative'
      ],
      position: {
        top: '0px'
      },
      data: {
        entity: {} as IProtocolo
      }
    }
  },
  portador: {
    component: FastPortadorComponent,
    config: {
      position: {
        top: '0px'
      },
      panelClass: [
        'dialog-sem-padding',
        'custom-container',
        'position-relative'
      ],
      data: {
        entity: {} as IPortador
      }
    }
  },
  tipo_procedimento: {
    component: FastTipoProcedimentoComponent,
    config: {
      panelClass: [
        'dialog-sem-padding',
        'custom-container',
        'position-relative'
      ],
      position: {
        top: '0px'
      },
      data: {
        entity: {} as ITipoProcedimento
      }
    }
  },
  procedimento: {
    component: FastProcedimentoComponent,
    config: {
      panelClass: [
        'dialog-sem-padding',
        'custom-container',
        'position-relative'
      ],
      position: {
        top: '0px'
      },
      data: {
        entity: {} as IProcedimento
      }
    }
  },
  fornecedor: {
    component: FastFornecedorComponent,
    config: {
      position: {
        top: '0px'
      },
      panelClass: [
        'dialog-sem-padding',
        'custom-container',
        'position-relative'
      ],
      data: {
        entity: {
          parceiro: {
            enderecos: [],
            contatos: []
          }
        } as IFornecedor
      }
    }
  },
  tipo_formulario: {
    component: FastTipoFormularioComponent,
    config: {
      panelClass: [
        'dialog-sem-padding',
        'custom-container',
        'position-relative'
      ],
      position: {
        top: '0px'
      },
      data: {
        entity: {} as ITipoFormulario
      }
    }
  },
  plano_saude: {
    component: FastPlanoSaudeComponent,
    config: {
      panelClass: [
        'dialog-sem-padding',
        'custom-container',
        'position-relative'
      ],
      position: {
        top: '0px'
      },
      data: {
        entity: {} as IPlanoSaude
      }
    }
  },
  paciente: {
    component: FastPacienteComponent,
    config: {
      position: {
        top: '0px'
      },
      panelClass: [
        'dialog-sem-padding',
        'custom-container',
        'position-relative'
      ],
      data: {
        entity: {
          parceiro: {
            enderecos: [],
            contatos: []
          }
        } as IPaciente
      }
    }
  },
  profissional: {
    component: FastProfissionalComponent,
    config: {
      position: {
        top: '0px'
      },
      panelClass: [
        'dialog-sem-padding',
        'custom-container',
        'position-relative'
      ],
      data: {
        entity: {
          parceiro: {
            enderecos: [],
            contatos: []
          }
        } as IProfissional
      }
    }
  },
  local_agendamento: {
    component: FastLocalAgendamentoComponent,
    config: {
      position: {
        top: '0px'
      },
      panelClass: [
        'dialog-sem-padding',
        'custom-container',
        'position-relative'
      ],
      data: {
        entity: {} as ILocalAgendamento
      }
    }
  },
  motivo_cancelamento: {
    component: FastMotivoCancelamentoComponent,
    config: {
      panelClass: [
        'dialog-sem-padding',
        'custom-container',
        'position-relative'
      ],
      position: {
        top: '0px'
      },
      data: {
        entity: {} as IMotivoCancelamento
      }
    }
  }
};

@Component({
  selector: 'fast-autocomplete',
  templateUrl: './fast-autocomplete.component.html',
  styleUrls: ['./fast-autocomplete.component.scss']
})
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export class FastAutocompleteComponent<T extends IEntity = any>
  implements OnInit, OnChanges {
  @Input() routesAuthorization: IRoute[] = [];
  @Input() data: any = {};
  @Input() useChange = false;
  @Input() controlReset = true;
  @Input() searchField = false;
  @Input() valueSearchField = '';

  @Input() insertType: InsertType | null = null;
  /**
   * Placeholder usado pelo input
   */
  @Input() placeholder = 'Digite aqui';
  /**
   * Exibe mensagem de erro, caso haja
   */
  @Input() errorMsg = '';
  /**
   * Mensagens de erro
   */
  @Input() messages: { [key: string]: string };

  @Input() displayField = 'id';

  @Input() displaySecondField = 'id';
  /**
   * Tipo de input do autocomplete
   */
  @Input() inputType = 'text';
  /**
   * Identifica se o campo é de preenchimento obrigatório
   */
  @Input() public readonly required = false;
  /**
   * Função para exibir os dados do autocomplete
   * @deprecated
   */
  @Input() displayWith: (obj: T) => string = obj => obj.toString();
  /**
   * O FormControl responsável por gerenciar o input
   * @required
   */
  @Input() control: UntypedFormControl;
  /**
   * Configuração de selecionar automaticamente o uncio resultado
   */

  @Input() public readonly autoFirst: boolean = true;
  /**
   * Inicia dados preenchido quando a busca for vazia
   */

  @Input() public readonly initDataWithEmpty: boolean = false;
  /**
   * EntityService usado para buscar os resultados
   * exibidos pelo autocomplete
   * @required
   */

  @Input() entityService: EntityService<T>;
  /**
   * Caso o usuario queira repassar sua própria função de busca
   * É possível atravês dessa props
   */
  @Input() public readonly searchFN: (where: any) => Observable<any> = null;
  /**
   * Função chamada sempre que há uma requisição a API
   * Implementa lógica caso seja nescessário filtar as entidades
   * vindas do banco de dados, ex: impedir auto relacionamento de entidades
   * @param entities entidades vindas da requisição
   * @tutorial rulesFilterEntities Cuidado com a perda de contexto do "this" use arrow functions
   * ou tenha certeza que o contexto chamado seja da sua classe externa com o bind.
   */
  @Input() rulesFilterEntities: (entities: T[]) => T[] = entities => entities;

  /**
   * Quando os resultados são carregados da api, este evento é acionado, repassando
   * os resultados retornados da api
   */
  @Output() public onLoadResults = new EventEmitter<T[]>();
  @Output() public clearSelection = new EventEmitter<boolean>();

  filteredEntities: T[] = [];

  /**
   * Id do dominio onde a infomação deve ser pesquisada
   */
  @Input() domain_id: string;

  @Input() domainPath = 'domain_id';

  @Input() value_order: string;

  @Input() orderByPath = 'order_by';

  @Input() pageValue: number;

  @Input() pagePath = 'page';

  @Input() pageSizeValue: number;

  @Input() pageSizePath = 'page_size';

  @Input() public readonly include: string[] = null;

  @Input() showDropDown = true;

  @Input() listOptionsPath = 'list_options';

  @Input() listOptionsValue = 'ACTIVE_ONLY';

  /**
   * Caso o usuario queira repassar sua própria função de busca
   * É possível atravês dessa props
   */
  @Input() public openDialogAddEntity: () => void = null;

  /**
   * Mostra a entidade selecionada
   * @param entity entidade a ser mostrada
   */
  @Input() displayWithEntityFn = (entity: T | string) => {
    if (!entity) return '';
    if (typeof entity === 'string') return entity;
    return entity[this.displayField];
  };
  @Output() onSelect = new EventEmitter<T>();

  /**
   * É possivel repassar paremetros adicionais para a requisição
   */
  @Input() params: { [param: string]: string } = {};
  /**
   * Caso o usuario queira ter controle total sobre a montagem de paramentros adicionais, é possivel
   * repassar uma funcao que deve retornar uma string formatada com query params que serão inseridos
   * antes da requisção ser feita
   */
  @Input() buildParams: () => string = this.prepareParams;

  @Input() readonly = false;

  @Input() readonly interceptorService: EntityService<T> | null = null;

  @Input() interceptorPath = 'id';

  @Input() interceptorDomainPath = 'domain_id';

  @Input() actionState = true;

  @Input() showBtnDialog = false;

  @Input() controlIsEnable = true;

  @Input() btnIcon = 'search';

  @Input() searchFieldPath = 'domain_id';

  @Input() public readonly interceptorInclude: string[] = null;

  @Input() useOnlyNumbers = false;

  @Input() entity_id: string;

  @Input() entityPathId = 'entity_id';

  /**
   * Lista de filtros que são usados quando o autocomplete for receber mais de um filtro e detalhe precisa
   * do useStringParams igual a false
   */
  @Input() concatDisplayFields: { alias: string; key: string }[] = [];

  /**
   * Emite eventos sempre que o autocomplete
   * precisar forçar a seleção de uma entidade
   * @description Emite o evento quando a entidade é selecionada
   */
  @Output() autoSelect: EventEmitter<T> = new EventEmitter();
  @Output() selectEntity: EventEmitter<T> = new EventEmitter();
  @Output() blur: EventEmitter<FocusEvent> = new EventEmitter();
  @Output() openDialog: EventEmitter<boolean> = new EventEmitter();

  @Input() forcedNotShowOptions = false;
  @Input() showDropdownIcon = false;

  public notShowOptions = false;
  public isLoading = false;
  public noResults = false;
  public isEmpty = false;

  constructor(
    protected tokenService: TokenService,
    public matDialog: MatDialog,
    public matSnackBar: MatSnackBar,
    public router: Router
  ) {
    this.buildParams = this.prepareParams;
  }

  protected getSearchField = (searchFieldPath = this.searchFieldPath) =>
    this.valueSearchField ? `&${searchFieldPath}=${this.valueSearchField}` : '';

  protected getDomain = (domainPath = this.domainPath) =>
    this.domainId ? `&${domainPath}=${this.domainId}` : '';

  protected getOrderBy = (orderByPath = this.orderByPath) =>
    this.value_order ? `&${orderByPath}=${this.value_order}` : '';

  protected getPage = (pagePath = this.pagePath) =>
    this.pageValue ? `&${pagePath}=${this.pageValue}` : '';

  protected getPageSize = (pageSizePath = this.pageSizePath) =>
    this.pageSizeValue ? `&${pageSizePath}=${this.pageSizeValue}` : '';

  protected getListOptions = (listOptionsPath = this.listOptionsPath) =>
    this.listOptionsValue ? `&${listOptionsPath}=${this.listOptionsValue}` : '';

  protected getInclude = (include = this.include) =>
    include ? this.getParamsByInclude(include) : '';

  protected interceptFn = () => {
    if (this.interceptorService) {
      return mergeMap((entity: any) => {
        return this.interceptorService
          .getEntitiesByParams(
            `${this.getDomain(this.interceptorDomainPath)}${this.getInclude(
              this.interceptorInclude
            )}`
          )
          .pipe(
            map(interceptorEntities => {
              return interceptorEntities.data.reduce((acc, crr) => {
                return entity.data.filter(
                  p =>
                    Utils.getDescendantProp(p, this.interceptorPath) ===
                    Utils.getDescendantProp(crr, this.interceptorPath)
                ).length > 0
                  ? [...acc, crr]
                  : acc;
              }, []);
            })
          );
      });
    }
    return map((entity: any) => entity.data);
  };

  onLoad() {
    this.isLoading = true;
    if (this.searchFN) {
      this.isLoading = true;
      const where = {
        include: this.include,
        order_by: this.value_order,
        page: this.pageValue,
        page_size: this.pageSizeValue,
        require_pagination: true,
        [this.domainPath]: this.domainId,
        list_options: 'ACTIVE_ONLY'
      };

      if (this.searchFieldPath && this.searchFieldPath.includes('&')) {
        const splitSearchField = this.searchFieldPath.split('&');
        splitSearchField.forEach((field, index) => {
          if (field.includes('='))
            where[field.split('=')[0]] = field.split('=')[1];
          else where[field] = this.valueSearchField;
        });
      } else {
        where[this.searchFieldPath] = this.valueSearchField;
      }

      if (this.entity_id) where[this.entityPathId] = this.entity_id;

      this.searchFN(where)
        .pipe(
          map(entities => this.rulesFilterEntities(entities)),
          tap(entities => {
            this.noResults = entities.data.length === 0;
          }),
          this.interceptFn()
        )
        .subscribe(
          entities => {
            this.isLoading = false;
            if (!this.forcedNotShowOptions) this.notShowOptions = false;
            this.filteredEntities = entities;
            if (
              this.filteredEntities &&
              this.filteredEntities.length !== 0 &&
              this.autoFirst
            ) {
              this.control.setValue(this.filteredEntities[0]);
              this.autoSelect.emit(this.filteredEntities[0]);
            }
          },
          (err: HttpErrorResponse) => this.displayError(err)
        );
    } else {
      this.entityService
        .getEntitiesByParams(
          `${this.getDomain()}${this.getSearchField()}${this.getInclude()}${this.getOrderBy()}${this.getPage()}${this.getPageSize()}${this.getListOptions()}`,
          undefined,
          true
        )
        .pipe(
          map(entities => this.rulesFilterEntities(entities)),
          tap(entities => {
            this.noResults = entities.data.length === 0;
          }),
          this.interceptFn()
        )
        .subscribe(
          entities => {
            this.isLoading = false;
            if (!this.forcedNotShowOptions) this.notShowOptions = false;
            this.filteredEntities = entities;
            if (
              this.filteredEntities &&
              this.filteredEntities.length !== 0 &&
              this.autoFirst
            ) {
              this.control.setValue(this.filteredEntities[0]);
              this.autoSelect.emit(this.filteredEntities[0]);
            }
          },
          (err: HttpErrorResponse) => this.displayError(err)
        );
    }
  }

  ngOnChanges() {
    if (this.tokenService.isLoggedIn()) {
      if (this.searchField) this.searchField = this.searchField;
      if (this.useChange) {
        if (this.controlReset) this.control.reset();
        if (this.initDataWithEmpty) {
          if (this.searchFN) {
            this.isLoading = true;

            const where = {
              include: this.include,
              order_by: this.value_order,
              page: this.pageValue,
              page_size: this.pageSizeValue,
              require_pagination: true,
              [this.domainPath]: this.domainId,
              list_options: 'ACTIVE_ONLY'
            };

            if (this.searchFieldPath && this.searchFieldPath.includes('&')) {
              const splitSearchField = this.searchFieldPath.split('&');
              splitSearchField.forEach((field, index) => {
                if (field.includes('='))
                  where[field.split('=')[0]] = field.split('=')[1];
                else where[field] = this.valueSearchField;
              });
            } else {
              where[this.searchFieldPath] = this.valueSearchField;
            }

            if (this.entity_id) where[this.entityPathId] = this.entity_id;

            this.searchFN(where)
              .pipe(
                map(entities => this.rulesFilterEntities(entities)),
                tap(entities => {
                  this.noResults = entities.data.length === 0;
                }),
                this.interceptFn()
              )
              .subscribe(
                entities => {
                  this.isLoading = false;
                  if (!this.forcedNotShowOptions) this.notShowOptions = false;
                  this.filteredEntities = entities;
                  if (
                    this.filteredEntities &&
                    this.filteredEntities.length !== 0 &&
                    this.autoFirst
                  ) {
                    this.control.setValue(this.filteredEntities[0]);
                    this.autoSelect.emit(this.filteredEntities[0]);
                  }
                },
                (err: HttpErrorResponse) => this.displayError(err)
              );
          } else {
            this.onLoad();
          }
        }
      }
    }
  }

  ngOnInit() {
    this.validateInputs();
    if (this.initDataWithEmpty) {
      if (this.searchFN) {
        this.isLoading = true;

        const where = {
          include: this.include,
          order_by: this.value_order,
          page: this.pageValue,
          page_size: this.pageSizeValue,
          require_pagination: true,
          [this.domainPath]: this.domainId,
          list_options: 'ACTIVE_ONLY'
        };

        if (this.searchFieldPath && this.searchFieldPath.includes('&')) {
          const splitSearchField = this.searchFieldPath.split('&');
          splitSearchField.forEach((field, index) => {
            if (field.includes('='))
              where[field.split('=')[0]] = field.split('=')[1];
            else where[field] = this.valueSearchField;
          });
        } else {
          where[this.searchFieldPath] = this.valueSearchField;
        }

        if (this.entity_id) where[this.entityPathId] = this.entity_id;

        this.searchFN(where)
          .pipe(
            map(entities => this.rulesFilterEntities(entities)),
            tap(entities => {
              this.noResults = entities.data.length === 0;
            }),
            this.interceptFn()
          )
          .subscribe(
            entities => {
              this.isLoading = false;
              if (!this.forcedNotShowOptions) this.notShowOptions = false;
              this.filteredEntities = entities;
              if (
                this.filteredEntities &&
                this.filteredEntities.length !== 0 &&
                this.autoFirst
              ) {
                this.control.setValue(this.filteredEntities[0]);
                this.autoSelect.emit(this.filteredEntities[0]);
              }
            },
            (err: HttpErrorResponse) => this.displayError(err)
          );
      } else {
        this.onLoad();
      }
    }
    this.control.valueChanges
      .pipe(
        debounceTime(300),
        filter(() => {
          // caso o valor selecionado seja um objeto, ele não faz uma requisição ao banco
          if (
            typeof this.control.value === 'object' &&
            this.control.value !== null &&
            this.control.value !== undefined
          ) {
            this.selectEntity.emit(this.control.value);
          }
          return typeof this.control.value === 'string';
        }),
        tap(() => {
          this.isLoading = true;
          this.noResults = false;
          this.notShowOptions = false;
        }),
        mergeMap(text => {
          if (text && text !== '') {
            if (!text.replace(/\s/g, '').length) {
              this.isEmpty = true;
              return of([]);
            }
            this.isEmpty = false;
            const textFilter = text.trim();
            if (this.searchFN) {
              const where = {
                include: this.include,
                order_by: this.value_order,
                page: this.pageValue,
                page_size: this.pageSizeValue,
                require_pagination: true,
                [this.domainPath]: this.domainId,
                list_options: 'ACTIVE_ONLY'
              };

              if (this.searchFieldPath && this.searchFieldPath.includes('&')) {
                const splitSearchField = this.searchFieldPath.split('&');
                splitSearchField.forEach((field, index) => {
                  if (field.includes('='))
                    where[field.split('=')[0]] = field.split('=')[1];
                  else where[field] = this.valueSearchField;
                });
              } else {
                where[this.searchFieldPath] = this.valueSearchField;
              }

              if (this.entity_id) where[this.entityPathId] = this.entity_id;

              if (textFilter) {
                if (
                  textFilter &&
                  textFilter.indexOf('#') === 0 &&
                  textFilter.split('#')[1]
                ) {
                  where[this.displaySecondField] = textFilter.split('#')[1];
                } else {
                  where[this.displayField] = textFilter.trim() + '%';
                }
              }

              return this.searchFN(where);
            }

            const anotherParams = this.buildParams();

            // SOMENTE NUMERO (/^\d+$/.test(text))
            // SOMENTE LETRAS E NUMEROS (/^\d+$/.test(text))
            // CONTEM ESPAÇO (/^\d+$/.test(text))
            // CONTEM CPF (/^\d{3}\.\d{3}\.\d{3}\-\d{2}$/.test(text))
            // CONTEM CNPJ (/^\d{2}\.\d{3}\.\d{3}\/\d{4}\-\d{2}$/.test(text))
            // CONTEM CARACTER ESPECIAL (/[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(text))

            let url = `${this.getDomain()}${this.getSearchField()}${this.getInclude()}${this.getOrderBy()}${this.getPage()}${this.getPageSize()}${this.getListOptions()}`;
            if (this.concatDisplayFields.length === 0) {
              url += `&${this.displayField}=${textFilter}%`;
              if (
                !Number.isNaN(Number(textFilter)) &&
                this.displaySecondField === 'id'
              ) {
                url = `${this.getDomain()}${this.getSearchField()}${this.getInclude()}${this.getOrderBy()}${this.getPage()}${this.getPageSize()}${this.getListOptions()}&${
                  this.displayField
                }=${textFilter}`;
              } else if (
                (/^[A-Za-z0-9]*$/.test(textFilter) || /\s/g.test(textFilter)) &&
                this.displaySecondField !== 'id'
              ) {
                if (
                  /^\d+$/.test(textFilter) &&
                  this.displaySecondField !== 'id'
                ) {
                  url = `${this.getDomain()}${this.getSearchField()}${this.getInclude()}${this.getOrderBy()}${this.getPage()}${this.getPageSize()}${this.getListOptions()}&${
                    this.displaySecondField
                  }=${textFilter}%`;
                } else {
                  url = `${this.getDomain()}${this.getSearchField()}${this.getInclude()}${this.getOrderBy()}${this.getPage()}${this.getPageSize()}${this.getListOptions()}&${
                    this.displayField
                  }=${textFilter}%`;
                }
              }
            } else {
              if (textFilter) {
                var where = {};
                if (!textFilter.includes('&')) {
                  if (
                    this.concatDisplayFields.length !== 0 &&
                    textFilter.includes('=')
                  ) {
                    const [inputKey] = textFilter.split('=');
                    const fieldIdx = this.concatDisplayFields.findIndex(
                      path => path.alias === inputKey.toLowerCase()
                    );
                    if (fieldIdx >= 0) {
                      this.concatDisplayFields.forEach((k, idx) => {
                        if (fieldIdx === idx) {
                          const txtVl = textFilter.split('=')[1];
                          where = {
                            ...where,
                            ...UtilsProject.assignNestedMergeValue(
                              where,
                              k.key,
                              `${txtVl}%`
                            )
                          };
                        }
                      });
                    }
                  } else if (this.displayField.includes('.')) {
                    where = {
                      ...where,
                      ...UtilsProject.assignNestedMergeValue(
                        where,
                        this.displayField,
                        `${textFilter}%`
                      )
                    };
                  } else {
                    where[this.displayField] = `${textFilter}%`;
                  }
                } else {
                  const splitTextFilter = textFilter.split('&');
                  splitTextFilter.forEach((field, index) => {
                    if (
                      this.concatDisplayFields.length !== 0 &&
                      field.includes('=')
                    ) {
                      const [inputKey] = field.split('=');
                      const fieldIdx = this.concatDisplayFields.findIndex(
                        path => path.alias === inputKey.toLowerCase()
                      );
                      if (fieldIdx >= 0) {
                        this.concatDisplayFields.forEach((k, idx) => {
                          if (fieldIdx === idx) {
                            const txtVl = field.split('=')[1];
                            where = {
                              ...where,
                              ...UtilsProject.assignNestedMergeValue(
                                where,
                                k.key,
                                `${txtVl}%`
                              )
                            };
                          }
                        });
                      }
                    } else {
                      where[this.displayField] = `${textFilter}%`;
                    }
                  });
                }
                url += `&${UtilsProject.flattenObject(where).join('&')}`;
              }
            }

            if (anotherParams) url += `&${anotherParams}`;
            return this.entityService.getEntitiesByParams(url, undefined, true);
          } else if (this.initDataWithEmpty) {
            this.isEmpty = false;
            if (this.searchFN) {
              const where = {
                include: this.include,
                order_by: this.value_order,
                page: this.pageValue,
                page_size: this.pageSizeValue,
                require_pagination: true,
                [this.domainPath]: this.domainId,
                list_options: 'ACTIVE_ONLY'
              };

              if (this.searchFieldPath && this.searchFieldPath.includes('&')) {
                const splitSearchField = this.searchFieldPath.split('&');
                splitSearchField.forEach((field, index) => {
                  if (field.includes('='))
                    where[field.split('=')[0]] = field.split('=')[1];
                  else where[field] = this.valueSearchField;
                });
              } else {
                where[this.searchFieldPath] = this.valueSearchField;
              }

              if (this.entity_id) where[this.entityPathId] = this.entity_id;

              return this.searchFN(where);
            }
            return this.entityService.getEntitiesByParams(
              `${this.getDomain()}${this.getInclude()}${this.getSearchField()}${this.getOrderBy()}${this.getPage()}${this.getPageSize()}${this.getListOptions()}`,
              undefined,
              true
            );
          } else {
            this.isEmpty = true;
            return of([]);
          }
        })
      )
      .pipe(
        map(entities => this.rulesFilterEntities(entities)),
        tap(entities => {
          this.noResults = entities.length === 0;
        }),
        this.interceptFn()
      )
      .subscribe(
        entities => {
          this.isLoading = false;
          this.filteredEntities = this.isEmpty ? [] : entities;

          // if (
          // this.filteredEntities &&
          //  this.filteredEntities.length === 1 &&
          //   this.autoFirst
          //  ) {
          //    this.control.setValue(this.filteredEntities[0]);
          //    this.autoSelect.emit(this.filteredEntities[0]);
          //    this.onSelect.emit(this.filteredEntities[0]);
          //  }
        },
        (err: HttpErrorResponse) => this.displayError(err)
      );
  }
  /**
   * Monta os paramentros adicionais a serem inseridos a request
   */
  private prepareParams(): string {
    if (!this.params) return '';
    const { params } = this;
    return Object.keys(params)
      .filter(key => params[key])
      .map(key => `${key}=${params[key]}`)
      .join('&');
  }
  private validateInputs() {
    if (!this.entityService && !this.searchFN) {
      throw new Error('EntityService or seach FN is required');
    }
    if (!this.control) {
      throw new Error('Formcontrol is required');
    }
  }
  /**
   * Pesquisa por uma entidade com base em um texto
   * @param value valor a ser buscao
   */
  protected getResults(value: string): Observable<T[]> {
    const anotherParams = this.buildParams();
    let url = `${
      this.displayField
    }=${value}%${this.getOrderBy()}${this.getPage()}${this.getPageSize()}${this.getListOptions()}`;
    if (anotherParams) url += `&${anotherParams}`;
    return this.entityService.getEntitiesByParams(url, this.domain_id, true);
  }

  getParamsByInclude(includes: string[]): string {
    if (includes.length > 0) return `&include=${includes.join(',')}`;
    return '';
  }
  getKey(): string {
    return Object.keys(this.control.errors)[0];
  }

  get domainId(): string {
    if (this.domain_id) return this.domain_id;
    else if (this.domain_id === undefined) return;
    else return this.tokenService.getDomain().id;
  }

  openDialogFast(): void {
    if (this.insertType) {
      this.matDialog
        .open(components[this.insertType].component, {
          ...components[this.insertType].config,
          disableClose: true,
          panelClass: components[this.insertType].config.panelClass,
          position: components[this.insertType].config.position,
          data: {
            ...components[this.insertType].config.data,
            ...this.data
          }
        })
        .afterClosed()
        .subscribe(componentEntity => {
          this.notShowOptions = false;
          if (componentEntity) {
            this.control.setValue(componentEntity);
            this.filteredEntities = [componentEntity, ...this.filteredEntities];
          } else {
            this.control.setValue(null);
          }
        });
    }
  }

  clearSelectValue() {
    this.notShowOptions = true;
    this.clearSelection.emit(true);
    this.isLoading = true;
    this.onLoad();
  }

  dialogClick() {
    this.notShowOptions = true;
    this.openDialog.emit(true);
  }

  validateOnlyNumbers(event) {
    if (
      !/^\d+$/.test(event.key) &&
      !event.ctrlKey &&
      event.key !== 'Backspace' &&
      event.key !== 'Delete' &&
      event.key !== 'Tab' &&
      event.key !== 'ArrowLeft' &&
      event.key !== 'ArrowRight'
    )
      return false;
  }

  displayError(err: HttpErrorResponse, showDefaultMsg = false) {
    const errorMsg = new ErroMessages({
      route: this.router.url,
      router: this.router,
      matSnackBar: this.matSnackBar,
      httpError: err,
      showDefaultMsg: showDefaultMsg,
      loginService: null,
      tokenService: this.tokenService,
      dialogComponent: ConfirmDialogComponent,
      matDialog: this.matDialog,
      dialogData: {
        config: {
          data: {
            title: 'Aviso - Erro ao realizar operação',
            bodyMessage: err.error,
            icon: 'pi pi-fw pi-info-circle text-orange-500 mb-2 mr-2',
            singleBtn: true
          } as ConfirmDialogData,
          disableClose: true,
          width: '500px'
        } as MatDialogConfig<any>
      }
    } as IErroMessages);
    errorMsg.showMessageObject(err.error);
    // errorMsg.checkError();
  }
}
